// removed by extract-text-webpack-plugin
module.exports = {"formatted-date-container":"_29cjaElkBUYfC8Tx7VLPU1","formatted-date-value":"_3IpGBf_BF8f51hIrTTeum9","positive":"_3blxolSjaiBhn5lPxqaUUX","negative":"_3_ImxYZk7h0e0umBwIWj2x","spin":"_1Akmc20ZQhc-4Tw3Vuoybd"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/FormattedDate/styles.scss
// module id = 884
// module chunks = 18